import {
  COMPLETED,
  IN_TRANSIT,
  READY,
  DRAFT,
} from 'src/constants/statusConstants';
import { OrderType } from 'src/types/orders';

interface Meta {
  count: number;
  limit: number;
  page: number;
}

type MetaState = Record<OrderType, Meta>;

export const getParams = ({
  orderType,
  page,
  meta,
  entity,
}: {
  orderType: OrderType;
  page: number;
  meta: MetaState;
  entity?: string;
}) => {
  const localMeta = meta[orderType];
  return {
    limit: localMeta.limit,
    page,
    ...(entity ? { entity } : {}),
  };
};

export const getStatusesForOrderType = (orderType: OrderType): string[] => {
  switch (orderType) {
    case 'draft':
      return [DRAFT];
    case 'ongoing':
      return [IN_TRANSIT];
    case 'completed':
      return [COMPLETED];
    case 'other':
      return [READY];
    default:
      return [];
  }
};


export const getStatusChipStyle = (status: string) => {
  const normalizedStatus = status.toLowerCase().trim();

  switch (normalizedStatus) {
    case 'pending_approval':
      return 'bg-[var(--bg-surface-2)] text-[var(--text-muted)]';
    case 'approved':
      return 'bg-[var(--color-primary)] text-white';
    case 'pending_payment':
      return 'bg-orange-500/20 text-orange-500';
    case 'ready':
      return 'bg-[var(--color-primary)] text-white';
    case 'rejected':
      return 'bg-[var(--color-error)] text-white';
    default:
      return 'bg-[var(--bg-surface-2)] text-[var(--text-main)]';
  }
};
